import { ORDER_FLOW_STEPS, type OrderFlowStep } from '../_constants/order-flow-steps.const'
import { OrderFlowMode } from '../_types/order-flow.types'

export type OrderFlowStepReachabilityContext = {
	flowMode: OrderFlowMode
	selectedAmbulanceSlug: string | null
	cartProductsLength: number
}

/**
 * Whether the user may land on {@link step} given cart and flow mode (mirrors `goToStep` guards in context).
 *
 * Used by the progress bar for click targets and prev/next arrows.
 */
export function canReachOrderFlowStep(
	step: OrderFlowStep,
	{ flowMode, selectedAmbulanceSlug, cartProductsLength }: OrderFlowStepReachabilityContext
): boolean {
	switch (step) {
		case ORDER_FLOW_STEPS.SELECT_AMBULANCE:
			return flowMode !== OrderFlowMode.DIRECT
		case ORDER_FLOW_STEPS.SELECT_PRODUCT:
			return (
				flowMode !== OrderFlowMode.DIRECT &&
				(flowMode !== OrderFlowMode.STANDARD || selectedAmbulanceSlug !== null)
			)
		case ORDER_FLOW_STEPS.PERSONAL_DETAILS:
			return cartProductsLength > 0
		default: {
			const _exhaustive: never = step
			return _exhaustive
		}
	}
}
